import { render } from "./Suggestion.vue?vue&type=template&id=29753569&ts=true"
import script from "./Suggestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./Suggestion.vue?vue&type=script&setup=true&lang=ts"

import "./Suggestion.vue?vue&type=style&index=0&id=29753569&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/components/autocomplete/Suggestion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29753569"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29753569', __exports__)) {
    api.reload('29753569', __exports__)
  }
  
  module.hot.accept("./Suggestion.vue?vue&type=template&id=29753569&ts=true", () => {
    api.rerender('29753569', render)
  })

}


export default __exports__